import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Form, Input, Select,Checkbox, Switch} from 'antd'
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'react-addons-update';
import './course.less'
const { Option } = Select
let dragingIndex = -1;
class BodyRow extends React.Component {
	render() {
		const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
		const style = { ...restProps.style, cursor: 'move' };

		let { className } = restProps;
		if (isOver) {
			if (restProps.index > dragingIndex) {
				className += ' drop-over-downward';
			}
			if (restProps.index < dragingIndex) {
				className += ' drop-over-upward';
			}
		}

		return connectDragSource(
			connectDropTarget(<tr {...restProps} className={className} style={style} />),
		);
	}
}
const rowSource = {
	beginDrag(props) {
		dragingIndex = props.index;
		return {
			index: props.index,
		};
	},
};
const rowTarget = {
	drop(props, monitor) {
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;
		if (dragIndex === hoverIndex) {
			return;
		}
		console.log('dragIndex', dragIndex)
		console.log('hoverIndex', hoverIndex)

		props.moveRow(dragIndex, hoverIndex);
		monitor.getItem().index = hoverIndex;
	},
};
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
}))(
	DragSource('row', rowSource, connect => ({
		connectDragSource: connect.dragSource(),
	}))(BodyRow),
);
class Course extends Component {
	constructor(props) {
		super(props)
		this.state = {
			hot: undefined,
			courseType: 0,
			total: 0,
			strageId: '',
			stageVisible:false,
			stageModelTitle:'更换阶段',
			strageName:'',
			changeSwitch: false,
			name: '',
			ids: '',
			// show:false,

			searchData: {
				pageNum: 1,
				pageSize: 20
			},
			columns: [
				{
					title: '课程名称',
					dataIndex: 'name',
					key: 'name',
					align: 'center',
					ellipsis: true,
					// render: (record)=> <span style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',maxWidth: '160px'}}>{record}</span>
				},
				// {
				// 	title: '课程类型',
				// 	dataIndex: 'type',
				// 	key: 'type',
				// 	align: 'center',
				// 	render: (record)=> <span>{record===1? '热门课程': '全栈教程'}</span>
				// },
				{
					title: '热门课程',
					dataIndex: 'hot',
					key: 'hot',
					align: 'center',
					render: (record)=> <span>{record===1? '是': '否'}</span>
				},
				{
					title: '课程标签',
					dataIndex: 'label',
					key: 'label',
					align: 'center'
				},
				{
					title: '章节数量',
					dataIndex: 'num',
					key: 'num',
					align: 'center'
				},
				{
					title: '创建人',
					dataIndex: 'admin',
					key: 'admin',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '推荐到资料广场',
					align: 'center',
					render: (text, record) =>{
					return(
						<div>
							<Switch key={record.id} defaultChecked={record.materialsChecked?true:false} onChange={(checked) => { 
							let id = record.id
								let arr = this.state.courseListData
								for(let i = 0; i<arr.length; i++){
									if(id === arr[i].id){
										arr[i].materialsChecked = checked===true? 1: 0
										this.setState({
											courseListData: arr
										})
									}
								}
							this.recommandCourse(checked, record)
						}}/>
						</div>
					)
					}
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							sessionStorage.setItem('courseType','modify')
							sessionStorage.setItem('courseId', record.id)
							this.props.history.push('/AddCourse')
						}}>编辑</span>
						<span style={{marginRight:'15px',color: '#277FFF', cursor: 'pointer'}} onClick={()=>{
							sessionStorage.setItem('courseId', record.id)
							this.props.history.push('/Catalogue')
						}}>目录</span>
						<span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除课程',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p>课程删除后不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delStage(record.id)
								},
							});
						}}>删除</span>
					</div>
				},
			],
			courseListData: [],
			notChanged: [],
			stgeColumns:[
				{
					title: '阶段名称',
					dataIndex: 'toStageName',
					key: 'toStageName',
					align: 'left'
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>{
						Number(sessionStorage.getItem('stageId')) === record.toStageId ?''
						: <Checkbox  checked={record.checked} disabled={record.disabled}
						onChange={(e)=>this.checkChange(record.toStageId,e)}></Checkbox> 
					}			
					</div>
				},
			],
			stageData:[],
			toStageId:'',
			selectedRowKeys:[]
		}
	}
	onChange = (record, e) => {
		console.log(record, e)
	}
	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			console.log(values)
		});
	}
	async getStageList() {
		axios.post('courseController/getList', {
			subjectId:sessionStorage.getItem('subjectId'),
			stageId: sessionStorage.getItem('stageId'),
			...this.state.searchData,
			name: this.state.name,
			type: this.state.courseType,
			hot: this.state.hot
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					total: res.data.data.total,
					courseListData: res.data.data.list,
					notChanged: res.data.data.list,
					searchData: {
						pageNum: res.data.data.pageNum,
						pageSize: res.data.data.pageSize
					}
				})
			}
		})
	}
	//获取可选的阶段
	async getStageData() {
		axios.post('courseController/getChangeStageList', {
			fromStageId:sessionStorage.getItem('stageId'),
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					stageData: res.data.data.toStages
				})
				this.setState(prevState => {
					const data = [...prevState.stageData];
				    data.forEach((v,i)=>{
						v.checked = false
						v.disabled = false
					})
					return { stageData: data };
				});
			}
		})
	}
	checkChange(id,e){
		this.setState({
			toStageId: id
		})
		this.setState(prevState => {
			const data = [...prevState.stageData];
			data.forEach((v,i)=>{
				if(v.toStageId === id){
					v.checked = !v.checked
				}else{
					v.disabled = !v.disabled
				}
			})
			return { stageData: data };
		});
	}
	delStage(id) {
		axios.get(`courseController/del/${id}`).then(res => {
			if(res.data.code === '200') {
				message.success('删除课程成功')
				this.getStageList()
			}else {
				message.success(res.data.msg)
			}
		})
	}
	// 取消批量选择课程
	getCancel(){
		this.setState({
			selectedRowKeys:[]
		})
		this.setState({
			show:false
		})
	}
	onSelectChange = (selectedRowKeys) => {
		this.setState({
			ids: selectedRowKeys,
			selectedRowKeys:selectedRowKeys
		})
		if(selectedRowKeys.length > 0){
			this.setState({
				show: true
			})
		}else{
			this.setState({
				show: false
			})
			this.setState({
				selectedRowKeys: []
			})
		}
	  }
	// 更新课程阶段
	getUpdate(){
		this.getStageData()
		this.setState({ stageVisible: true, stageModelTitle: '更换阶段'})
	}
	// 更新阶段提交
	handleOk = (e) => {
		axios.post('courseController/saveChangeStage', {
			fromCourseIds: this.state.ids,
			fromStageId:sessionStorage.getItem('stageId'),
			toStageId:this.state.toStageId,
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({ stageVisible: false })
				message.success('更新阶段成功')
				this.setState({
					selectedRowKeys:[]
				})
				this.setState({
					show:false
				})
				this.getStageList()
			} else {
				message.error(res.data.msg)
			}
		})
	}
	recommandCourse(flag, obj) {
		Modal.confirm({
			title: '操作',
			okText: "确认",
			cancelText: "取消",
			content: `确定要${flag?'':'取消'}推荐到资料广场吗`,
			onOk: () => {
				axios.post('courseController/recommend', {id:obj.id,scopeType: 1, status: flag=== true?1:0}).then(res => {
					console.log(res)
					if(res.data.code === '200') {
						message.success(res.data.msg)
						this.getStageList()
					}
				})
			},
			onCancel: () => {
				this.getStageList()
			}
		});
	}
	componentDidMount() {
		this.getStageList()
	}
	getUploadUrl = v => {
		this.setState({
			uploadUrl: v
		})
	}
	components = {
		body: {
			row: DragableBodyRow,
		},
	};
	moveRow = (dragIndex, hoverIndex) => {
		const { courseListData } = this.state;
		const dragRow = courseListData[dragIndex];
		this.setState(
			update(this.state, {
				courseListData: {
					$splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
				},
			}),
		);
		let oldSort = []
		for (let i = 0; i < this.state.notChanged.length; i++) {
			oldSort.push({ sort: this.state.notChanged[i].sort, id: this.state.courseListData[i].id })
		}
		axios.post('courseController/updateSort',oldSort).then(res => {
			if(res.data.code === '200' )
			oldSort = []
		})


	};
	render() {
		const { columns, courseListData, total,show,selectedRowKeys,stageVisible,stageModelTitle,stgeColumns,stageData} = this.state;
		const pagination = {
			showSizeChanger: true,
			total: total,
			pageSize: this.state.searchData.pageSize,
			pageSizeOptions: ['20', '40', '80', '200'],
			showTotal: () => `共 ${total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.getStageList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.getStageList(searchData)
			},
		}
		const rowSelection = {
			selectedRowKeys,
			onChange: this.onSelectChange
		};

		return (
			<div className="course">
				<div style={{display: 'flex',justifyContent: 'space-between'}}>
					<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>课程管理</span>
					<span className="my-button-txt" onClick={()=> {
						sessionStorage.setItem('courseType','')
						sessionStorage.setItem('courseId','')
						this.props.history.push('/Stage')
					}}>返回上一级</span>
				</div>

				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
						<Input allowClear value={this.state.name} style={{ width: '260px', height: '40px', marginRight: '20px' }}
						placeholder="请输入课程名称"
						onChange={(e)=>{
							this.setState({
									name: e.target.value
							})
						}}
						></Input>
						<Select  placeholder="热门课程" value={this.state.hot} allowClear style={{ width: 140, height: '40px' }} onChange={(value)=>{
							this.setState({
								hot: value
							})
						}}>
							<Option value="0">否</Option>
							<Option value="1">是</Option>
						</Select>
						<Button className='my-button-primary' type='primary' onClick={() => {
							this.getStageList()
						}}>搜索</Button>
						<span className="my-button-txt" style={{marginLeft: '20px'}} onClick={()=> {
							this.setState({name: '',hot: undefined,courseType: 0},()=> {
								this.getStageList()
							})
						}}>重&nbsp;置</span>
					</div>
					<Button className='my-button-primary' type='primary' onClick={() => {
						sessionStorage.setItem('courseType','add')
						this.props.history.push('/AddCourse')
					 }}>新增课程</Button>
				</div>
				<DndProvider backend={HTML5Backend}>
					<Table
					    rowSelection={rowSelection}
						dataSource={courseListData}
						columns={columns}
						components={this.components}
						rowKey={record => record.id}
						rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
						onRow={(record, index) => ({
							index,
							moveRow: this.moveRow,
						})}
						pagination={pagination}
					/>
				</DndProvider>
				{show &&<div style={{position:'absolute',bottom:'30px'}}>
					<span style={{marginRight:'20px'}}>已选{selectedRowKeys.length}个课程</span>
					 <Button onClick={()=>{
						this.getCancel()
					 }}>
						取消</Button>
					<Button className='my-button-primary' style={{ marginLeft: '20px' }} type='primary' onClick={() => {
						this.getUpdate()
					}}>更换阶段</Button>

				</div>}
				<Modal
					getContainer={true}
					title={stageModelTitle}
					maskClosable={false}
					okText="确认"
					cancelText="取消"
					visible={stageVisible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ stageVisible: false }) }}
					destroyOnClose
					width={600}
				>
					<Form labelCol={{ span: 15 }} wrapperCol={{ span: 28 }} onSubmit={this.handleOk}>
						<div style={{marginBottom:'20px'}}>当前阶段：<span style={{color:'#277fff'}}>{sessionStorage.getItem('stageName')}</span></div>
						<Table
							dataSource={stageData}
							columns={stgeColumns}
							pagination={false}
							rowKey={record => record.toStageId}
							rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
						/>
					</Form>
				</Modal>
			</div>
		)
	}
}

export default Form.create()(Course)